var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.news)?_c('notifications-payment-detail',{attrs:{"img-no":_vm.imgNo,"is-loading":_vm.isLoading,"no_news":_vm.no_news,"news":_vm.news,"bank":_vm.bank,"news_type":_vm.news_type}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }